import axios from 'axios';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const ordersAxiosInstanceDev = axios.create({
  ...axiosBaseConfig,
  baseURL: 'http://localhost:5050/api',
});

setupInterceptors(ordersAxiosInstanceDev, true);

export default ordersAxiosInstanceDev;
